import { render, staticRenderFns } from "./GroupContactSales.vue?vue&type=template&id=df961590&"
import script from "./GroupContactSales.vue?vue&type=script&lang=js&"
export * from "./GroupContactSales.vue?vue&type=script&lang=js&"
import style0 from "./GroupContactSales.vue?vue&type=style&index=0&id=df961590&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports